import { endpoints } from "@/config/endpoints";
import { apiService } from "@/services/apiService";

export default {
  /**
   * Get all Apple Maps accounts
   * @returns {Promise} Promise with the response
   */
  getAccounts() {
    return apiService.get(endpoints.appleMaps.accounts);
  },

  /**
   * Add a new Apple Maps account
   * @returns {Promise} Promise with the response
   */
  addAccount() {
    return apiService.post(endpoints.appleMaps.accounts);
  },

  /**
   * Authorize an Apple Maps account
   * @param {Object} authData - The authorization data
   * @returns {Promise} Promise with the response
   */
  authorizeAccount(authData) {
    return apiService.post(endpoints.appleMaps.authorize, authData);
  },

  /**
   * Delete an Apple Maps account
   * @param {string|number} id - The account ID to delete
   * @returns {Promise} Promise with the response
   */
  deleteAccount(id) {
    return apiService.delete(endpoints.appleMaps.accountById(id));
  }
};
